import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import CircularProgress from 'material-ui/CircularProgress';

var BaseService = require('../../service/baseservice');

var emptyIndustry = {
      _id: "",
      name: "",
      officialName:"",
      searchTerms:""
    };

/**
 * A modal dialog can only be closed by selecting one of the actions.
 */
export default class IndustryEditDialog extends Component {
  state = {
    hasUnsavedChanges: false,
    editedNameOnce: false,
    editedIdOnce: false,
    isNew: true,
    saving: false,
    industry: emptyIndustry
  };

  componentWillReceiveProps(newProps) {
    this.setState({
      industry: newProps.industry,
        saving: false,
        isNew: newProps.industry._id === ""
      });
  }

  handleFormEdit = (state) => {
    state.hasUnsavedChanges = true;
    return state;
  }

  handleNameEdit = (event) => {
    var state = this.state;
    state.industry.name = event.target.value;
    state.editedNameOnce = true;
    state = this.handleFormEdit(state);
    this.setState(state);
  }

  handleSearchTermsEdit = (event) => {
    var state = this.state;
    state.industry.searchTerms = event.target.value;
    state = this.handleFormEdit(state);
    this.setState(state);
  }

  notEditedActions() {
    var cancelTitle = this.props.industry._id === "" ? "Peruuta" : "Sulje";
    return [
      <FlatButton
        label={cancelTitle}
        onTouchTap={this.props.handleClose}
      />
    ];
  }

  savingActions() {
    return [<CircularProgress size={30} thickness={2} style={{marginRight:'60px'}} />];
  }

  editedActions() {
    var saveTitle = this.state.isNew ? "Luo toimiala" : "Tallenna muutokset";
    var cancelTitle = this.state.isNew ? "Peruuta" : "Peruuta muutokset";
    return [
      <FlatButton
        label={cancelTitle}
        onTouchTap={this.props.handleClose}
      />,
      <FlatButton
        label={saveTitle}
        primary={true}
        onTouchTap={() => this.handleSaveChanges()}
        disabled={!this.isValidName()}
      />
    ];
  }

  handleSaveChanges() {
    this.setState({saving: true});
    if (this.state.isNew) {
        BaseService.addIndustry(this.state.industry).then(industry => {
          this.setState({ industry: emptyIndustry });
          this.props.handleClose();
        });
    } else {
      BaseService.editIndustry(this.state.industry).then(industry => {
        this.setState({ industry: emptyIndustry });
        this.props.handleClose();
      });
    }
  }

  isValidName() {
    return this.state.industry.name.length > 0;
  }

  render() {
    var dialogActions = this.state.hasUnsavedChanges ? this.editedActions() : this.notEditedActions();

    if (this.state.saving) {
      dialogActions = this.savingActions();
    }

    var headTitle = this.state.isNew ? "Uusi toimiala" : "";
    var nameErrorText = (this.isValidName() || !this.state.editedNameOnce) ? "" : "Toimiala vaatii nimen";

    return (
        <Dialog
        title={headTitle}
        actions={dialogActions}
        modal={true}
        open={this.props.enabled}>
          <TextField
            floatingLabelText="Nimi"
            multiLine={true}
            value={this.state.industry.name}
            errorText={nameErrorText}
            onChange={this.handleNameEdit}
            style={{width:"400px"}}
            /><br />
          <TextField
            floatingLabelText="Hakutermit"
            multiLine={true}
            value={this.state.industry.searchTerms}
            onChange={this.handleSearchTermsEdit}
            style={{width:"400px"}}
            /><br/>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/IndustriesPage/IndustryEditDialog.js